import React, {FunctionComponent} from "react";
import {Link as RouterLink, LinkProps} from "react-router-dom";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles({
  root: {
    color: "inherit"
  }
});

const Link: FunctionComponent<LinkProps> = (props) => {

  const { children } = props;
  const classes = useStyles();

  return <RouterLink className={classes.root} {...props}>{children}</RouterLink>

};

export default Link;
